import { ConfigProvider } from 'antd';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { SettingsStore } from 'src/stores/SettingsStore/SettingsStore';

export const AppConfigProvider = observer(
    ({ children }: PropsWithChildren<object>) => {
        const { i18n } = useTranslation();

        const currentLocale = SettingsStore.supportedLocalesMap[i18n.language];

        return (
            <ConfigProvider locale={currentLocale}>{children}</ConfigProvider>
        );
    },
);
